module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-unocked-fc5167463a585c7cfe28436af78cf56a.svg";